<template>
  <div
    v-if="rootEntity"
    class="modal-wrapper"
  >
    <input
      v-model="searchTerm"
      class="entity-search"
      placeholder="Pesquisar..."
    >

    <div :class="clsx('tree-wrapper', { 'disabled': $progress.isInProgress })">
      <div
        v-if="searchTerm && !visibleRootEntity"
        class="not-found"
      >
        Nenhuma entidade encontrada: {{ searchTerm }}
      </div>
      <tree-item
        :item="visibleRootEntity"
        label="name"
        @click="onChangeEntity($event)"
      />
    </div>
  </div>
</template>

<script>
import debounce from "lodash.debounce";
import clsx from "clsx";

import TreeItem from "@/components/Tree/TreeItem.vue";

import filterTree from "@/util/filter-tree";
import { changeActiveEntity } from "@/_services/entity.service";
import { userService } from "@/_services";
import { EventBus, events } from "@/_helpers/event-bus";
import { getUserSession } from "@/_services/localstorage";

export default {
  name: "EntitySelector",
  components: {
    TreeItem,
  },
  props: {
    rootEntity: {
      type: Object,
      default: () => null,
    },
  },
  data: () => ({
    searchTerm: "",
    visibleRootEntity: null,
    activeEntityId: -1,
    profileEntities: null,
  }),
  watch: {
    searchTerm(value) {
      this.onSearchEntity(value);
    },
  },
  created() {
    this.visibleRootEntity = this.rootEntity;

    const userSession = getUserSession();
    this.activeEntityId = userSession.activeentity;
    this.profileEntities = userSession.profileEntities;

    this.resetEntitiesStatus(this.visibleRootEntity);
    this.openSelectedEntity(this.visibleRootEntity);
  },
  methods: {
    onSearchEntity(searchTerm) {
      if (searchTerm.length) {
        this.fetchEntities(this, searchTerm);
      } else {
        this.visibleRootEntity = this.rootEntity;
      }
    },
    fetchEntities: debounce(async (context, searchTerm) => {
      const lowerCaseSearchTerm = searchTerm.toLowerCase();
      context.visibleRootEntity = filterTree(context.rootEntity, (entity) => entity.name.toLowerCase().includes(lowerCaseSearchTerm));
    }, 350),

    /**
     *
     * @param {Entity} entity
     * @returns {Promise<void>}
     */
    async onChangeEntity(entity) {
      if (entity.id === this.activeEntityId) {
        this.$modal.hide("EntitySelector");
        return;
      }

      this.$progress.start();

      await changeActiveEntity(entity.id);

      await userService.info();

      EventBus.$emit(events.CHANGED_ENTITY, entity);

      this.$progress.stop();

      this.$modal.hide("EntitySelector");
    },
    resetEntitiesStatus(entity, isEnabled = null) {
      entity.isHighlighted = false;
      entity.isExpanded = false;
      entity.isDisabled = isEnabled !== null ? !isEnabled : true;

      let childIsEnabled = isEnabled;

      if (this.profileEntities[entity.id]) {
        entity.isDisabled = false;

        if (this.profileEntities[entity.id].is_recursive) {
          childIsEnabled = true;
        }
      }

      if (entity.children && entity.children.length) {
        entity.children.forEach(child => this.resetEntitiesStatus(child, childIsEnabled));
      }
    },
    openSelectedEntity(entity) {
      if (entity.id === this.activeEntityId) {
        entity.isHighlighted = true;
        return true;
      }

      if (entity.children && entity.children.length) {
        const childIsSelected = entity.children.some(child => this.openSelectedEntity(child));

        if (childIsSelected) {
          entity.isHighlighted = true;
          entity.isExpanded = true;
        }

        return childIsSelected;
      }

      return false;
    },
    clsx,
  },
};
</script>

<style lang="scss">

.vm--modal {
  overflow: auto;
}

.modal-wrapper {
  display: flex;
  flex-direction: column;

  padding: 1em;

  .modal-title {
    margin: 0;
  }

  .entity-search {
    margin-top: 0.5em;
    margin-bottom: 1em;
  }

  .not-found {
    font-style: italic;
    text-align: center;
    padding: 2em;
  }
}

.disabled {
  opacity: 0.3;
  pointer-events: none;
  cursor: not-allowed !important;
}
</style>
